import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ token, url1, children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (!token || !url1) return;

        const newSocket = io(`${url1}:443`, {
            path: '/ws',
            query: {
                auth_token: token,
            },
            secure: true,
        });

        setSocket(newSocket);

        newSocket.on('connect', () => {
            console.log('🟢 Socket підключено');
        });

        newSocket.on('disconnect', () => {
            console.log('🔴 Socket відключено');
        });

        newSocket.on('error', (err) => {
            console.error('❗ Socket помилка:', err);
        });


        
        return () => {
            newSocket.disconnect();
        };
    }, [token, url1]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};